module.exports = __webpack_public_path__ + "img/image-writing.43a0e9f8.png";